import React, { Component } from 'react';
import _ from 'lodash';
import CrgtEvent from '../CrgtEvent';
import './index.scss';

export default class Container extends Component {
  
  render() {
    const { size='default', style, href, target, cid, vid, nativePage, event = 'doNothing', ...restProps } = this.props;
    let containerClass = size === 'default' ? 'fullContainer' : 'partContainer';
    let params = {};
    if (event === 'openUrl') {
      params = (!_.isNil(href) && !_.isNil(target))? { url: href, target } : {}
    }
    if (event === 'openView') {
      params = (!_.isNil(cid) && !_.isNil(vid)) ? { cid, vid } : {}
    }
    if (event === 'openNativeView') {
      params =  { nativePage }
    }
   
    const clickEvent = event !== undefined && function () { CrgtEvent[`${event}`](params) };

    return (
      <div className={containerClass} style={style}  onClick={clickEvent} {...restProps}>{this.props.children}</div>
    )
  }
}

 